var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.core.js
 ** module id = 54
 ** module chunks = 0
 **/